function toggleDescription() {
    var shortDescription = document.getElementById('short-description');
    var fullDescription = document.getElementById('full-description');
    var readMore = document.getElementById('read-more');
    var readLess = document.getElementById('read-less');
    
    if (shortDescription.style.display === 'none') {
      shortDescription.style.display = 'block';
      fullDescription.style.display = 'none';
      readMore.style.display = 'block';
      readLess.style.display = 'none';
    } else {
      shortDescription.style.display = 'none';
      fullDescription.style.display = 'block';
      readMore.style.display = 'none';
      readLess.style.display = 'block';
    }
  }